<!--
  대시보드 트래픽
  관리장비 트래픽 현황 위젯

  @since: 2018-09-06
  @author: mk.ko

  * (2019-01-31) 현재 사용되지 않음
-->

<template>
  <div ref="chartWrapper"
       class="widget-wrapper pad0">
    <!--<div class="widget-contents">-->
      <!--<div class="widget-contents-wrapper">-->
        <data-table class="bs bs-data-table bs-data-table-slim"
                    ref="widgetDataTable"
                    :fields="widgetFields"
                    :complexHeader="widgetComplexHeader"
                    :data="widgetData"
                    :virtualScrolling="false"
                    :fieldSortable="false">
          <!--class="bs bs-data-table bs-data-table-basic bs-data-table-th-gray">-->
          <!--class="bs bs-q-treeGrid bs-q-treeGrid-default ico-square"-->
        </data-table>
      </div>
    <!--</div>-->
  <!--</div>-->
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetDevTrafficStatus',
    components: {},
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 3,
        title: 'widgetDevTrafficStatus',
        isLock: false,
        isMove: true,
        isResize: true,
        isMaximum: true,
        eventBus: true,
        widgetData: [],
        totalAttack: 0,
        totalByte: 0,
        totalPacket: 0,
        totalLog: 0
      }
    },
    computed: {
      locale () {
        return this.$store.state.common.locale.locale
      },
      widgetFields () {
        return [
          {
            name: 'rank',
            title: '순위',
            width: 40
          },
          // {
          //   name: 'fluctuation',
          //   title: '변동',
          //   align: 'center',
          //   width: 60,
          //   itemTemplate: this.getRankFluctuationTemplate
          // },
          {
            name: 'device_name',
            title: '장비명',
            align: 'left',
            width: 200
          },
          {
            name: 'risk',
            title: '위험도',
            width: 60,
            iconTemplate: this.getRiskIconClass
          },
          {
            name: 'byte',
            title: '바이트',
            align: 'right',
            width: 80,
            itemTemplate: this.byteConverter
            // ### START quasar q-tree
            // type: 'quasar',
            // itemTemplate: (data, rowData, fieldName) => {
            //   const nodes = [
            //     {
            //       label: 'test-1',
            //       children: [
            //         {label: 'test-1-1'},
            //         {label: 'test-1-2'}
            //       ]
            //     }
            //   ]
            //
            //   return {
            //     template: 'q-tree',
            //     type: 'item',
            //     data: {
            //       nodes: nodes,
            //       nodeKey: 'label'
            //     }
            //   }
            // }
            // ### END quasar q-tree

            // itemTemplate: () => {
            //   return {
            //     template: 'q-input',
            //     data: {
            //       type: 'text',
            //       clearable: true,
            //       class: 'bs bs-q-input'
            //     }
            //   }
            // }
            // itemTemplate: () => {
            //   return {
            //     template: 'q-checkbox',
            //     type: 'item',
            //     data: {
            //       trueValue: 1,
            //       falseValue: 0,
            //       class: 'bs bs-q-select bs-q-select-default'
            //     }
            //   }
            // }
          },
          {
            name: 'byte',
            title: '비율',
            type: 'quasar',
            width: 80,
            itemTemplate: this.getRatioPerTotalTemplate
          },
          {
            name: 'byte_variation',
            title: '변화량',
            align: 'right',
            width: 60,
            itemTemplate: this.getRatioTemplate
          },
          {
            name: 'packet',
            title: '패킷',
            align: 'right',
            width: 80,
            itemTemplate: this.getScale
          },
          {
            name: 'packet',
            title: '비율',
            type: 'quasar',
            width: 80,
            itemTemplate: this.getRatioPerTotalTemplate
          },
          {
            name: 'packet_variation',
            title: '변화량',
            align: 'right',
            width: 60,
            itemTemplate: this.getRatioTemplate
          },
          {
            name: 'log_count',
            title: '로그 수',
            align: 'right',
            width: 80,
            itemTemplate: this.getScale
          },
          {
            name: 'log_count',
            title: '비율',
            type: 'quasar',
            width: 80,
            itemTemplate: this.getRatioPerTotalTemplate
          },
          {
            name: 'log_variation',
            title: '변화량',
            align: 'right',
            width: 60,
            itemTemplate: this.getRatioTemplate
          }
        ]
      },
      widgetComplexHeader () {
        return []
        // return [
        //   {
        //     start: 'rank',
        //     end: 'fluctuation',
        //     title: '순위'
        //   }
        // ]
      }
    },
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      async getWidgetContentsData () {
        const sampleData = []
        const gridData = []

        // Progress 출력 여부
        this.showProgress(true)

        const topN = 10

        for (let i = 0; i < topN; i++) {
          sampleData.push([
            Math.round(Math.random() * (topN - i) * 100000),
            Math.round(Math.random() * 1489346),
            Math.round(Math.random() * 50000),
            Math.round(Math.random() * 20000),
            Math.round(Math.random() * (topN - i) * 100000),
            Math.round(Math.random() * 1489346),
            Math.round(Math.random() * 50000),
            Math.round(Math.random() * 20000)
          ])
        }

        sampleData.sort((first, second) => {
          return first[0] < second[0]
        })

        // let typeData = ['TCP ACK Flooding', 'UDP SYN Flooding', 'Invalid Source IP Address', 'Illegal TCP Flag', 'ICMP Unreachable Limit', 'virus-trojan-IRC-ptrn(php).090601602.ECSC#', 'virus-trojan-downloader(dnf5).090601802.ECSC#', 'UDP Land', '사용자 정의 룰 #50012', 'Unknown(0)']
        let typeData = ['개발센터', '인사팀 FW', '물류 FW', 'STMS 방화벽', '차기제품개발팀 FW', 'IPS/DDoS랩 IPS', '구매팀 FW', '관문망 FW', 'BLUEMAX NGF', 'BLUEMAX TAMS']
        const shuffle = array => {
          let counter = array.length

          // While there are elements in the array
          while (counter > 0) {
            // Pick a random index
            let index = Math.floor(Math.random() * counter)

            // Decrease counter by 1
            counter--

            // And swap the last element with it
            let temp = array[counter]
            array[counter] = array[index]
            array[index] = temp
          }

          return array
        }
        typeData = shuffle(typeData)
        const ratio = (now, prev) => {
          let result
          if (now > prev) {
            result = now / prev * 100 - 100
          } else if (now < prev) {
            result = (prev / now * 100 - 100) * -1
          } else {
            result = 0
          }

          return result
        }

        this.totalAttack = 0
        this.totalByte = 0
        this.totalLog = 0

        for (let i = 0; i < topN; i++) {
          this.totalAttack += sampleData[i][0]
          this.totalByte += sampleData[i][1]
          this.totalPacket += sampleData[i][2]
          this.totalLog += sampleData[i][3]
          gridData.push({
            rank: (i + 1),
            fluctuation: Math.round(Math.random() * 100) * Math.pow(-1, Math.round(Math.random() * 1 + 1)),
            device_name: typeData[i],
            risk: (Math.floor(Math.random() * 5) + 1),
            byte: sampleData[i][1],
            byte_variation: ratio(sampleData[i][1], sampleData[i][5]),
            packet: sampleData[i][2],
            packet_variation: ratio(sampleData[i][2], sampleData[i][6]),
            log_count: sampleData[i][3],
            log_variation: ratio(sampleData[i][3], sampleData[i][7])
          })
        }

        this.widgetData = gridData

        // Progress 출력 여부
        // this.showProgress(false)
        setTimeout(this.showProgress(false), 1500)
      },
      getRiskIconClass (value) {
        if (value) {
          // // value : low: 0, medium: 1, how: 2
          // const setValue = _.add(_.multiply(value, 2), 2)
          // value : info:0, low: 1, medium: 2, how: 3
          // const setValue = (value === 0) ? _.add(value, 1) : _.multiply(value, 2)
          const setValue = _.add(value, 1)
          return {
            icon: `ico-hazard hazard-0${setValue}`
          }
        }
      },
      getRankFluctuationTemplate (value) {
        let result = ''
        if (value > 0) {
          result = `<span style="color:red;"><i class="material-icons">keyboard_arrow_up</i> ${value}</span>`
        } else if (value < 0) {
          result = `<span style="color:blue;"><i class="material-icons">keyboard_arrow_down</i> ${Math.abs(value)}</span>`
        } else {
          result = `<span style="color:gray;"><i class="material-icons">remove</i></span>`
        }
        // return `${result} ${Math.abs(value)}`
        return result
      },
      getRatioTemplate (value) {
        let result = ''
        // const numberFormat = (num, fixed = 0) => {
        //   return parseInt(num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')).toFixed(fixed)
        // }
        if (value > 0) {
          result = `<span style="color:red;">${this.getScale(value, 0)}%</span>`
        } else if (value < 0) {
          result = `<span style="color:blue;">${this.getScale(value, 0)}%</span>`
        } else {
          result = `<span style="color:gray;">${this.getScale(value, 0)}%</span>`
        }
        return result
      },
      getRatioPerTotalTemplate (data, rowData, fieldName) {
        let ratio = 0

        switch (fieldName) {
          case 'attack_count':
            ratio = data / this.totalAttack * 100
            break
          case 'byte':
            ratio = data / this.totalByte * 100
            break
          case 'packet':
            ratio = data / this.totalPacket * 100
            break
          case 'log_count':
            ratio = data / this.totalLog * 100
            break
          default:
            ratio = 0
        }

        return {
          template: 'q-progress',
          data: {
            percentage: Math.round(ratio, 0),
            showPercentage: true,
            height: '20px'
          }
        }
      },
      getScale (value, fixed) {
        return this.kmgtConverter(value, fixed)
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    watch: {}
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
